module.exports = __webpack_public_path__ + "img/ico-restore.3267072b.svg";